import {older_generation_cost_adjustment,get_skip_shape_regex} from "./dbcsi_external.js";






function   pick_aurora_shape(regionInfo, config) {



// regionInfo.shapes = array of different Aurora Shapes to consider
// config = details about the target values and other properties of the database



     var working_IOPS = config.IOPS;
     var working_VCPU = config.VCPU;
     var working_Memory = config.Memory;
     var working_Throughput = config.Throughput;
     var working_DiskSpace = config.DiskSpace;

      // set working_IOPS equal to config.AdjustedIOPS if it exists else set it to config.IOPS
      if (config.AdjustedIOPS) {
        working_IOPS = config.AdjustedIOPS;
      }
      if (config.AdjustedMemory) {
        working_Memory = config.AdjustedMemory;
        // console.log("pick_rds_shape", "Using AdjustedMemory", working_Memory);
        }
      if(config.AdjustedThroughput) {
         working_Throughput = config.AdjustedThroughput;
       }
      if (config.AdjustedVCPU) {
        working_VCPU = config.AdjustedVCPU;
      }


      //Now work on Aurora
      // console.log("pick_aurora_shaoe");

        var auroraItems = regionInfo.shapes;

        function auroraCompareCost(a, b) {
          // Use toUpperCase() to ignore character casing
          // const itemA = ((config.UseRI=='RI') && a.AuroraPG1yrNURI * 1 > 0 ? a.AuroraPG1yrNURI*1 : a.AuroraPGOD*1) * 10000 + a.VCPU*1;
          // const itemB = ((config.UseRI=='RI') && b.AuroraPG1yrNURI * 1 > 0 ? b.AuroraPG1yrNURI*1 : b.AuroraPGOD*1) * 10000 + b.VCPU*1;
          var itemA = 0;
          var itemB = 0;
          if (config.UseRI=="RI+SP") {
            itemA =  older_generation_cost_adjustment(Math.min(a.AuroraPGOD*1, 
                          (  (a.AuroraPG1yrNURI * 1 > 0) ? a.AuroraPG1yrNURI*1 : 9999),
                          (  (a.AuroraPG1yrNUSP * 1 > 0) ? a.AuroraPG1yrNUSP*1 : 9999)
                          ), a) * 10000 - a.VCPU*1;
            itemB =  older_generation_cost_adjustment(Math.min(b.AuroraPGOD*1, 
                          (  (b.AuroraPG1yrNURI * 1 > 0) ? b.AuroraPG1yrNURI*1 : 9999),
                          (  (b.AuroraPG1yrNUSP * 1 > 0) ? b.AuroraPG1yrNUSP*1 : 9999)
                          ), b) * 10000 - b.VCPU*1;              
          }
          if ((config.UseRI=="SP-Only") || (config.UseRI=="SP") ) {
            itemA =  older_generation_cost_adjustment(Math.min(a.AuroraPGOD*1, 
                          (  (a.AuroraPG1yrNUSP * 1 > 0) ? a.AuroraPG1yrNUSP*1 : 9999)
                          ), a) * 10000 - a.VCPU*1;
            itemB =  older_generation_cost_adjustment(Math.min(b.AuroraPGOD*1, 
                          (  (b.AuroraPG1yrNUSP * 1 > 0) ? b.AuroraPG1yrNUSP*1 : 9999)
                          ), b) * 10000 - b.VCPU*1;              
          }
          if (config.UseRI=="RI") {
            itemA =  older_generation_cost_adjustment(Math.min(a.AuroraPGOD*1, 
                          (  (a.AuroraPG1yrNURI * 1 > 0) ? a.AuroraPG1yrNURI*1 : 9999)
                          ), a) * 10000 - a.VCPU*1;
            itemB =  older_generation_cost_adjustment(Math.min(b.AuroraPGOD*1, 
                          (  (b.AuroraPG1yrNURI * 1 > 0) ? b.AuroraPG1yrNURI*1 : 9999)
                          ), b) * 10000 - b.VCPU*1;              
           }
          if (config.UseRI=="OD") {
            itemA =  older_generation_cost_adjustment(Math.min(a.AuroraPGOD*1
                          ), a) * 10000 - a.VCPU*1;
            itemB =  older_generation_cost_adjustment(Math.min(b.AuroraPGOD*1
                          ), b) * 10000 - b.VCPU*1;              
           }

          let comparison = 0;
          if (itemA > itemB) {
            comparison = 1;
          } else if (itemA < itemB) {
            comparison = -1;
          } else if (itemA == itemB) {
          // final sort is by Name in REVERSE order.  This should make r6i.xlarge appear ahead of r5.xlarge
            if (a.Name > b.Name) {
              comparison = -1;
            } else if (a.Name < b.Name) {
              comparison = 1;
            }
          }
          return comparison;
        }
      auroraItems.sort(auroraCompareCost);

      // Skip Shape Filter (prefs.rdsSkipShape_preset / rdsSkipShape_expr), shared by the RDS-Oracle, EC2, EC2+FSxN, and Aurora pickers
      var regex = get_skip_shape_regex(config.frozen_prefs);
      let doSkipRegex = (regex !== null);
      
      //Now work on Aurora
      var auroraSelected = null;
      let closeness = -999;
      let closeness_string = "";
      let match_string = "";
      
      let gap_memory=  0;
      let gap_network=  0;
      let gap_vcpu=  0;
      
      for (var bii = 0; bii < auroraItems.length; bii++) {

       if (auroraItems[bii].AuroraPGOD*1>0) {
         // decide if we want to include T shapes.  
         // maybe if the algo is to use OptimizeIO then ensure we have OptimizeIO pricing for that shape
         //  (config.frozen_prefs.aurora_algo!="auro5" || auroraItems[bii].AuroraPGOptimOD*1>0 )
         //skip over shapes we don't want to use
         if (
                config.frozen_prefs.tshape_algo == "N" &&
                auroraItems[bii].Name.substring(0, 1) == "t"
              ) {
            // console.log("skipping T shape",auroraItems[bii].Name);
          }  else if (
                config.frozen_prefs.nvme_shape_algo == "Y" &&
                ( !auroraItems[bii].InstanceStorage || ( auroraItems[bii].InstanceStorage == "EBS only" ) )
              ) {
              // console.log("skipping non-localNVME shape",auroraItems[bii].Name);
          } else if (
                config.frozen_prefs.aurora_algo!="auro5" &&
                !( auroraItems[bii].AuroraPGOptimOD*1>0 )
              ) {
              // console.log("shape is not available for OptimizedIO",auroraItems[bii].Name);
          } else if (doSkipRegex && regex.test(auroraItems[bii].Name.toLowerCase())) {
              // console.log("skipping shape matching Skip Shape Filter",auroraItems[bii].Name);
          } else if (config.UseRI=="SP-Only" && auroraItems[bii].AuroraPG1yrNUSP==null) {
            // if UseRI is SP-Only, then skip any shapes without SP pricing
            // console.log("not database savings plan shape. skip",auroraItems[bii].Name);
          } else
          {
          
            
          match_string = `db.${auroraItems[bii].Name} with ${auroraItems[bii].VCPU} VCPU, ${auroraItems[bii].Memory} GB, ${(auroraItems[bii].Network / 8).toFixed(0)} Network MB/s`;
          if (config.frozen_prefs.nvme_shape_algo == "Y") {
            match_string += `, ${auroraItems[bii].InstanceStorage}`;
          }
  
          //TODO: have flag to choose or not choose t* shapes
          if (
            auroraItems[bii].VCPU * 1 >= working_VCPU * 1 &&
            auroraItems[bii].Memory * 1 >= working_Memory * 1 &&
            auroraItems[bii].Network / 8  >= working_Throughput * 1
          ) {
            //check if we can use T shapes
            // console.log("substr: "+auroraItems[bii].Name.substring(0,4));
  
                auroraSelected = auroraItems[bii];
                // console.log("Submit: found aurora match:"+auroraItems.Name)
                break;
                
            } else {
              //the shape was not selected.
              let new_closeness = Math.min((auroraItems[bii].VCPU * 1 - working_VCPU * 1) / auroraItems[bii].VCPU,0) +
                Math.min((auroraItems[bii].Memory * 1 - working_Memory * 1 ) / auroraItems[bii].Memory,0) +
                Math.min((auroraItems[bii].Network /8 - working_Throughput * 1 ) / (auroraItems[bii].Network / 8),0) ;

              
              if (new_closeness > closeness) {
                gap_memory=  Math.max((working_Memory * 1 ) - auroraItems[bii].Memory * 1 ,0);
                gap_network=  Math.max((working_Throughput * 1 ) - auroraItems[bii].Network /8 ,0);
                // console.log("network", working_Throughput, auroraItems[bii].Network, gap_network);
                gap_vcpu=  Math.max((working_VCPU * 1 ) - auroraItems[bii].VCPU * 1 ,0);
                // closeness_string = `Next closest match: db.${auroraItems[bii].Name} with ${auroraItems[bii].VCPU} VCPU, ${auroraItems[bii].Memory} GB, ${(auroraItems[bii].Network / 8).toFixed(0)} Network MB/s`;
                closeness_string = `Next closest match: db.${auroraItems[bii].Name} with ${auroraItems[bii].VCPU} VCPU${(gap_vcpu>0) ? " (short "+gap_vcpu.toFixed(1)+" VCPU)" : ""}, ${auroraItems[bii].Memory} GB${(gap_memory>0) ? " (short "+gap_memory+" GB)" : ""}, ${auroraItems[bii].Network / 8} Network MB/s${(gap_network>0) ? " (short "+gap_network+" MB/s)" : ""}`;
  
                closeness=new_closeness;
              }
            }
          }  
       } //end if (auroraItems[bii].AuroraPGOD*1>0) {  
      } //end loop
      

      // console.log(match_string);
      // console.log("RDS", closeness_string);
      if (auroraSelected==null) {
        auroraSelected = { Name: null};
      }

      auroraSelected.closeness_string = closeness_string;
      auroraSelected.match_string = match_string;
      auroraSelected.aurora_gap_memory = gap_memory;
      auroraSelected.aurora_gap_network = gap_network;
      auroraSelected.aurora_gap_vcpu = gap_vcpu;
      return auroraSelected;
    }





function   calculate_aurora_config(regionInfo, auroraItemSelected, config) {
//based on matchConfig, line 2008
//based on targetconfig_aurora() . line 3360

// **************************
// Aurora Configuration
// **************************

// auroraItemSelected = a document contain specific rdsItem (shape) and its details, closeness_string, and match_string
// config = details about the target values and other properties of the database



     var working_IOPS = config.IOPS;
     var working_VCPU = config.VCPU;
     var working_Memory = config.Memory;
     var working_Throughput = config.Throughput;
     var working_DiskSpace = config.DiskSpace;

      // set working_IOPS equal to config.AdjustedIOPS if it exists else set it to config.IOPS
      if (config.AdjustedIOPS) {
        working_IOPS = config.AdjustedIOPS;
      }
      if (config.AdjustedMemory) {
        working_Memory = config.AdjustedMemory;
        // console.log("pick_rds_shape", "Using AdjustedMemory", working_Memory);
        }
      if(config.AdjustedThroughput) {
         working_Throughput = config.AdjustedThroughput;
       }
      if (config.AdjustedVCPU) {
        working_VCPU = config.AdjustedVCPU;
      }

      // Step 2 - prepare additional fields describing the configuration 
      
      
            //TODO hard code backup for now
      config.BackupType = 'none';
      config.Backup = '0';
      config.SnapshotDays = '1';


      if ((auroraItemSelected.Name == null)) {
        //if rds_shape==N/A, then don't pick an Aurora shape either
        // console.log("Submit: No matching Aurora found for "+ config.database)
        // config.iomb_warnings = "Y";
        config.aurora_shape = "N/A";
        config.targetconfig_aurora = {
          summaryText: "DBCSI's current logic is not able to auto-size this configuration for Aurora. Please reach out to your AWS Database Specialist for help.",
          monthly_estimate: "N/A",        
          shape: "N/A",
          shape_OD: "N/A",
          shape_RI: "N/A",
          shape_SP: "N/A",
          shape_max_vcpu: "N/A",
          shape_optimize_vcpu: "N/A",
          requested_vcpu: "N/A",
          shape_memory: "N/A",
          requested_memory: "N/A",
          shape_throughput: "N/A",
          requested_throughput: "N/A",
          shape_summaryText: "",
          ebs_data_type: "N/A",
          ebs_data_size: "N/A",
          ebs_data_iops: "",
          ebs_data_summaryText1: "",
          ebs_data_summaryText2: "",
          backup_style: "N/A",
          ebs_backup_type: "N/A",
          ebs_backup_size: "N/A",
          ebs_backup_iops: "",
          ebs_backup_snap_size: "",
          ebs_backup_summaryText1: "",
          ebs_backup_summaryText2: "",
          license_summaryText: "",
          comments: "",
          warnings: "No matching shape found",
          closeness_string: auroraItemSelected.closeness_string,
          match_string: ""
          
        }            ;
      } else if ((working_DiskSpace*1 > 256000)) {
        
        config.aurora_shape = auroraItemSelected.Name;
        config.targetconfig_aurora = {
          summaryText: "Aurora does not currently support disk space > 256TB",
          monthly_estimate: "N/A",        
          shape: auroraItemSelected.Name,
          shape_OD: "N/A",
          shape_RI: "N/A",
          shape_SP: "N/A",
          shape_max_vcpu: "N/A",
          shape_optimize_vcpu: "N/A",
          requested_vcpu: "N/A",
          shape_memory: "N/A",
          requested_memory: "N/A",
          shape_throughput: "N/A",
          requested_throughput: "N/A",
          shape_summaryText: "",
          ebs_data_type: "N/A",
          ebs_data_size: "N/A",
          ebs_data_iops: "",
          ebs_data_summaryText1: "",
          ebs_data_summaryText2: "",
          backup_style: "N/A",
          ebs_backup_type: "N/A",
          ebs_backup_size: "N/A",
          ebs_backup_iops: "",
          ebs_backup_snap_size: "",
          ebs_backup_summaryText1: "",
          ebs_backup_summaryText2: "",
          license_summaryText: "",
          comments: "Aurora does not currently support disk space > 256TB",
          warnings: "Aurora does not currently support disk space > 256TB",
          closeness_string: auroraItemSelected.closeness_string,
          match_string: auroraItemSelected.match_string
          
        }            ;
      } else
      {


        // Step 2b - This is a fit for RDS.  So, describe it
        

      var tempConfig = {
        summaryText: "Select an Aurora Shape to continue...",
        monthly_estimate: "N/A",
        shape: "N/A",
        shape_OD: "N/A",
        shape_RI: "N/A",
        shape_SP: "N/A",
        shape_max_vcpu: "N/A",
        shape_optimize_vcpu: "N/A",
        requested_vcpu: "N/A",
        shape_memory: "N/A",
        requested_memory: "N/A",
        shape_throughput: "N/A",
        requested_throughput: "N/A",
        shape_summaryText: "",
        shape_cost: "",
        ebs_data_type: "N/A",
        ebs_data_size: "N/A",
        ebs_data_iops: "",
        ebs_data_summaryText1: "",
        ebs_data_summaryText2: "",
        ebs_data_cost: "",
        // "backup_style" : "N/A",
        // "ebs_backup_type" : "N/A",
        // "ebs_backup_size" : "N/A",
        // "ebs_backup_iops" : "",
        ebs_backup_snap_size: "",
        ebs_backup_summaryText1: "",
        ebs_backup_summaryText2: "",
        ebs_backup_cost: "",
        iops_summaryText1: "",
        iops_summaryText2: "",
        license_summaryText: "",
        comments: "",
        iomb_warnings: "",
        cpu_warnings: "",
        iops_warnings: "",
        UseMAZ: "No",
        UseSE2: "No"
      };


      tempConfig.shape = auroraItemSelected.Name;
      tempConfig.InstanceStorage = auroraItemSelected.InstanceStorage;
      tempConfig.shape_OD = auroraItemSelected.AuroraPGOD;
      tempConfig.shape_RI = auroraItemSelected.AuroraPG1yrNURI;
      tempConfig.shape_SP = auroraItemSelected.AuroraPG1yrNUSP;      
      tempConfig.shape_max_vcpu = auroraItemSelected.VCPU;
      tempConfig.shape_optimize_vcpu = auroraItemSelected.VCPU;
      tempConfig.requested_vcpu = working_VCPU;
      tempConfig.requested_memory = working_Memory;
      tempConfig.shape_memory = auroraItemSelected.Memory;
      tempConfig.requested_throughput = working_Throughput;
      tempConfig.shape_throughput = auroraItemSelected.Throughput;
      tempConfig.shape_network = auroraItemSelected.Network;
      tempConfig.shape_baseline_network = auroraItemSelected.baseline_Network;
      tempConfig.ebs_data_type = config.VolumeType;
      tempConfig.ebs_data_size = working_DiskSpace;
      // tempConfig.comments = this.comments.Aurora;
      if (typeof tempConfig.comments === "undefined") {
        tempConfig.comments = "";
      }
      tempConfig.UseMAZ = config.UseMAZ;
      tempConfig.RIused="OD";
      
      if ((working_DiskSpace*1 > 256000) ) {
        
        tempConfig.comments = tempConfig.comments + "[Aurora does not currently support disk space > 256TB] ";
        
        if ((tempConfig.diskspace_warnings==undefined) || (tempConfig.diskspace_warnings.indexOf("Aurora does not currently support disk space")==-1)) {
          tempConfig.diskspace_warnings = tempConfig.diskspace_warnings + "[Aurora does not currently support disk space > 256TB] ";
        }  
      }      

      if (1 * tempConfig.requested_vcpu > 1 * tempConfig.shape_max_vcpu) {
        tempConfig.cpu_warnings =
          tempConfig.cpu_warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_vcpu +
          " VCPUs. ";
      }
      if (1 * tempConfig.requested_memory > 1 * tempConfig.shape_memory) {
        tempConfig.cpu_warnings =
          tempConfig.cpu_warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_memory +
          " GB of memory. ";
      }
      if (
        1 * tempConfig.requested_throughput >
        1 * tempConfig.shape_network / 8
      ) {
        tempConfig.iomb_warnings =
          tempConfig.iomb_warnings +
          "The shape " +
          tempConfig.shape +
          " does not support " +
          tempConfig.requested_throughput +
          " MB/s of Network throughput. ";
      }
      if (
        1 * tempConfig.requested_throughput >
        1 * tempConfig.shape_baseline_network / 8
      ) {
        tempConfig.iomb_warnings =
          tempConfig.iomb_warnings +
          "The shape " +
          tempConfig.shape +
          " has baseline Network throughput of " +
          (tempConfig.shape_baseline_network/8).toFixed(0) +
          "MB/s, which is less than the target of " +
          tempConfig.requested_throughput +
          " MB/s of Network throughput. ";
      }
      
      var useIOoptimized = false;
      
      if (config.frozen_prefs.aurora_algo=="auro5") {
        if (auroraItemSelected.AuroraPGOptimOD*1>0) {
          // we are good to use OptimIO mode
          // console.log("Pricing using Aurora I/O-Optimized mode.  ");
          useIOoptimized = true;
        } else {
          console.log("This shape does not offer Aurora I/O-Optimized mode. ");
          useIOoptimized = false;
        }  
        //todo : maybe add more logic on when it is OK to use AuroraIOoptimized?  Is it available for all instances?  Is it available in all regions?  Circle back once officially launched.
      }

      var shapeCost = 0;
      var mazString = "";
      var mazFactor = 1.0;
      if (tempConfig.UseMAZ=="Yes") {
        mazString=" (2 instances: Primary and Replica)";
        mazFactor = 2.0;
      }
      
  // Update UseRI based on the selectedItem
     var temp_UseRI = config.UseRI;
     if (config.UseRI=="RI+SP") {
       // did we pick RI or SP?
       // default to RI
       temp_UseRI='RI';
       // but switch to SP if it exists and is less than RI
       // need to tweak this when Savings Plans supports SE2
       if ( tempConfig.shape_SP!=null && (tempConfig.shape_RI == null || tempConfig.shape_RI*1>tempConfig.shape_SP*1) ) {
         // console.log("RI+SP switching to SP");
         temp_UseRI="SP";
       } else {
         // console.log("RI+SP NOT switching to SP");
       }
     }
  
     if (config.UseRI=="SP-Only") {
       temp_UseRI='SP';
     }
      
      if ((temp_UseRI=='RI') && tempConfig.shape_RI > 0) {
        shapeCost = tempConfig.shape_RI * 730 * mazFactor;
        tempConfig.shape_summaryText = "Aurora Compute";
        
        if (useIOoptimized) {
          // shapeCost = auroraItemSelected.AuroraPGOptim1yrNURI * 730 * mazFactor;
          // just multiply regular RI by 1.3
          shapeCost = shapeCost * 1.3;
          
          tempConfig.shape_summaryText = "Aurora IO-Optimized Compute";
        }
        
         tempConfig.shape_summaryText += mazString+" Monthly estimate (using 1-year Reserved Instance pricing for Aurora PostgreSQL): $" +
          shapeCost.toFixed(2);
        tempConfig.RIused="RI";
      } else if ((temp_UseRI=='SP') && tempConfig.shape_SP > 0) {
        shapeCost = tempConfig.shape_SP * 730 * mazFactor;
        tempConfig.shape_summaryText = "Aurora Compute";
        
        if (useIOoptimized) {
          // shapeCost = auroraItemSelected.AuroraPGOptim1yrNURI * 730 * mazFactor;
          // just multiply regular RI by 1.3
          shapeCost = shapeCost * 1.3;
          
          tempConfig.shape_summaryText = "Aurora IO-Optimized Compute";
        }
        
         tempConfig.shape_summaryText += mazString+" Monthly estimate (using 1-year Database Savings Plans pricing for Aurora PostgreSQL): $" +
          shapeCost.toFixed(2);
        tempConfig.RIused="SP";
      } else {
        shapeCost = tempConfig.shape_OD * 730 * mazFactor;
        tempConfig.shape_summaryText = "Aurora Compute";

        if (useIOoptimized) {
          shapeCost = auroraItemSelected.AuroraPGOptimOD * 730 * mazFactor;
          
          tempConfig.shape_summaryText = "Aurora IO-Optimized Compute";
        }

        tempConfig.shape_summaryText += mazString+" Monthly estimate (using On-Demand pricing for Aurora PostgreSQL): $" +
          shapeCost.toFixed(2);
      }
      tempConfig.shape_cost = shapeCost;

      var auroraSnapshotSize =
        ((config.Backup * 60 * 60 * 24) / 1024) * config.SnapshotDays +
        working_DiskSpace * 0.7;
      // assume some factor (0.7?) for initial backup because RDS says most customers don't need backup space with RDS, so it must be less than 1.0.  Maybe accounts for allocated but unused blocks

      tempConfig.ebs_data_summaryText1 =
        "Aurora Storage: " + working_DiskSpace + " GB";
        
      var storageSpaceCost = 0;
      
      if (useIOoptimized) {  
        storageSpaceCost = working_DiskSpace * regionInfo.aurora_gb_optim;
        tempConfig.ebs_data_summaryText2 =
          "Aurora I/O-Optimized Storage Monthly estimate: $" +
          (storageSpaceCost).toFixed(2);
          
      } else {
        storageSpaceCost = working_DiskSpace * regionInfo.aurora_gb;
        tempConfig.ebs_data_summaryText2 =
          "Aurora Storage Monthly estimate: $" +
          (storageSpaceCost).toFixed(2);
        
      }  

      if (1 * working_DiskSpace > 256000) {
        tempConfig.warnings =
          tempConfig.warnings + "Aurora Disk Size must be less than 256 TB. ";
      }

      // throughput (in terms of 8K pages), divided by 10 to convert peaks to averages, then multiplied out to a month.
      // var monthly_iops = (config.Throughput * 1024) / 8 / 10 * 3600 * 730;
      var monthly_iops = (tempConfig.requested_throughput * 1024) / 8 / 10 * 3600 * 730;
      var iops_cost = 0;
      var ios_persecond = 0;
      if ((config.frozen_prefs.aurora_algo=="auro2")||(config.frozen_prefs.aurora_algo=="auro1")) {
        //25% of tempConfig.shape_OD * 730
        iops_cost=tempConfig.shape_OD * 730 * 0.25;
        monthly_iops=iops_cost/regionInfo.aurora_io;
        //calculate per second as an integer, so that it is easier to re-enter into pricing calculator
        ios_persecond=Math.ceil(monthly_iops/(730 * 60 * 60 ));
        monthly_iops=ios_persecond*730*60*60;
        iops_cost=monthly_iops*regionInfo.aurora_io;

        tempConfig.iops_summaryText1 =
          "Aurora IO costs: (estimated "+ios_persecond+" IOs per second, based on 25% of on-demand compute cost of "+tempConfig.shape+")";
        tempConfig.iops_summaryText2 =
          "Aurora IO costs Monthly estimate: $" +
          (iops_cost).toFixed(2);
        tempConfig.ebs_data_iops = monthly_iops;
        tempConfig.storage_assumptions = "Aurora Storage IO costs are estimated as being 25% the cost of the on-demand cost of the chosen Aurora instance shape.";
      } else if (config.frozen_prefs.aurora_algo=="auro3") {
        //35% of tempConfig.shape_OD * 730
        iops_cost=tempConfig.shape_OD * 730 * 0.35;
        monthly_iops=iops_cost/regionInfo.aurora_io;
        //calculate per second as an integer, so that it is easier to re-enter into pricing calculator
        ios_persecond=Math.ceil(monthly_iops/(730 * 60 * 60 ));
        monthly_iops=ios_persecond*730*60*60;
        iops_cost=monthly_iops*regionInfo.aurora_io;
        
        tempConfig.iops_summaryText1 =
          "Aurora IO costs: (estimated "+ios_persecond+" IOs per second, based 35% of on-demand compute cost of "+tempConfig.shape+")";
        tempConfig.iops_summaryText2 =
          "Aurora IO costs Monthly estimate: $" +
          (iops_cost).toFixed(2);
        tempConfig.ebs_data_iops = monthly_iops;
      } else if (config.frozen_prefs.aurora_algo=="auro4") { //auro4
        
                //calculate per second as an integer, so that it is easier to re-enter into pricing calculator
        ios_persecond=Math.ceil(monthly_iops/(730 * 60 * 60 ));
        monthly_iops=ios_persecond*730*60*60;
        iops_cost=monthly_iops*regionInfo.aurora_io;

        tempConfig.iops_summaryText1 =
          "Aurora IOs: " +
          (monthly_iops / 1000000).toFixed(2) +
          " million IO requests per month (based on " +
          ios_persecond +
          " IO requests per second)";
        tempConfig.iops_summaryText2 =
          "Aurora IO costs Monthly estimate: $" +
          (iops_cost).toFixed(2);
        tempConfig.ebs_data_iops = monthly_iops;  
        tempConfig.storage_assumptions = "Aurora Storage IO costs are roughly estimated based on estimating the number of IOs by taking the peak Throughput target divided by 10 (to roughly convert peak to average) and then dividing by 8KB page sizes.";
        
      } else { //auro5 - I/O Optimized
        iops_cost=0;
        tempConfig.iops_summaryText1 =
          "Priced using Aurora IO-Optimized mode";
        tempConfig.iops_summaryText2 =
          "Aurora IO-Optimized mode";
        tempConfig.ebs_data_iops = 0;  
        tempConfig.storage_assumptions = "Aurora Storage IO costs are estimated assuming the use of the Aurora I/O-Optimized deployment mode.";
        
      }

      var tempCost = shapeCost +
          storageSpaceCost +
          Math.max(0, regionInfo.aurora_backup * (1 * auroraSnapshotSize - working_DiskSpace)) +
          iops_cost;
      tempConfig.ebs_backup_cost =  Math.max(0, regionInfo.aurora_backup * (1 * auroraSnapshotSize - working_DiskSpace));
      tempConfig.ebs_data_cost = storageSpaceCost + iops_cost;

      var RIstring = "";
      if ((tempConfig.RIused=='RI') ) {
        RIstring = " using 1-year No Upfront Reserved Instance pricing";
      } else if ((tempConfig.RIused=='SP') ) {
        RIstring = " using 1-year No Upfront Database Savings Plans pricing";
      } else {
        RIstring = " using On-Demand pricing";
      }

      if (useIOoptimized) {
        tempConfig.summaryText =
          "Aurora-PostgreSQL"+mazString+" Monthly = [" +
          auroraItemSelected.Name + RIstring +
          "] + [Aurora Storage @ " +
          working_DiskSpace +
          " GB] + " +
          " [using I/O Optimized mode]" +
          " = $" +
          (tempCost).toFixed(2);
        
      } else {
        tempConfig.summaryText =
          "Aurora-PostgreSQL"+mazString+" Monthly = [" +
          auroraItemSelected.Name + RIstring +
          "] + [Aurora Storage @ " +
          working_DiskSpace +
          " GB] + " +
          " [Aurora IOs @ " +
          ios_persecond +
          " requests/second] " +
          // "+ [additional " +
          // Math.max(0, 1 * auroraSnapshotSize - working_DiskSpace).toFixed(0) +
          // " GB of Snapshots]" +
          " = $" +
          (tempCost).toFixed(2);
      }  

      tempConfig.ebs_backup_summaryText1 =
        "Aurora Backup: First " +
        working_DiskSpace +
        " GB of backup storage is included (Free backup for up to 100% of provisioned storage).  Estimated size of snapshots is " +
        auroraSnapshotSize.toFixed(0) +
        " GB.";
      tempConfig.ebs_backup_summaryText2 =
        "Aurora Backup Monthly estimate (Additional " +
        Math.max(0, 1 * auroraSnapshotSize - working_DiskSpace).toFixed(0) +
        " GB): $" +
        Math.max(
          0,
          regionInfo.aurora_backup * (1 * auroraSnapshotSize - working_DiskSpace)
        ).toFixed(2);
      tempConfig.ebs_backup_snap_size = 1 * auroraSnapshotSize - working_DiskSpace;
      
      tempConfig.monthly_estimate=Math.round(tempCost*100)/100;



        
        var target_aurora = tempConfig;
        // console.log("Submit: aurora=" + target_aurora.summaryText);
        config.aurora_shape = target_aurora.shape;
        config.targetconfig_aurora = target_aurora;
        config.targetconfig_aurora.closeness_string = auroraItemSelected.closeness_string;
        config.targetconfig_aurora.match_string = auroraItemSelected.match_string;
        if (target_aurora.iomb_warnings != "") {
            // config.iomb_warnings = "Y";
        }
      }



      return config;
    }


export {pick_aurora_shape};

export {calculate_aurora_config};